import { useCallback, useState } from 'react';
import { useOverlayContext } from 'seagull';
import { routes } from '~/constants';
import { useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { handlePromise } from '~/infra/utils';
import { useOpenCopyLinkModal } from './useOpenCopyLinkModal/useOpenCopyLinkModal';
export function useCopyDirectLink() {
    const { api } = useStoreActions();
    const { t: commonTexts } = useLocaleKeys('common');
    const overlayContext = useOverlayContext();
    const { openCopyLinkForAgreement } = useOpenCopyLinkModal();
    const [isFetchingLink, setIsFetchingLink] = useState(false);
    const copyDirectLink = useCallback(async (relationshipId, data)=>{
        setIsFetchingLink(true);
        const result = data.type === 'invoice' && data.isAdHoc ? await handlePromise(api.invoice.adhocApprovalLink(data.id)).then((r)=>r.success ? {
                success: true,
                data: r.data.notificationId
            } : r) : await handlePromise(api.relationship.getDirectLink(relationshipId, data));
        if (!result.success) {
            setIsFetchingLink(false);
            overlayContext.showErrorToast(commonTexts.toasts.failedToGenerateLink(), 'direct-link-error-toast');
            return '';
        }
        setIsFetchingLink(false);
        const url = "https://".concat(window.location.host).concat(routes.notification(result.data));
        await openCopyLinkForAgreement({
            url,
            testId: 'copy-direct-link-copy'
        });
        return result.data;
    }, [
        api,
        commonTexts.toasts,
        openCopyLinkForAgreement,
        overlayContext
    ]);
    return {
        isFetchingLink,
        copyDirectLink
    };
}
